export default __webpack_public_path__ + "static/media/notes-and-videos.d14fde70.svg";